// The rainfall reading is an unsigned 12-bit counter value. The counter value is converted to water depth in millimeters (mm) using the ConversionFormulaScale parameter. The ConversionFormulaOffset parameter can be used to add an offset (in millimeters) to the final value. Convert the 12-bit counter value ($rdg in code below) to water depth ($rf in code below) using the following algorithm:

/*
$rf = 0.0;

if ( $rdg == 0xFFF ) {
  $rf = null; // display reading as “invalid”
} else {
  $kfactor = (float)$ConversionFormulaScale;
  $offset = (float)$ConversionFormulaOffset;
  $val = ($rdg * $kfactor) + $offset;

  if ( $val > 0.0 ) {
    $rf = $val;
  }
}
*/

export function rainfall(
  reading: number,
  scale: number,
  offset: number,
  frequency: number
): number {
  const kfactor = scale
  const rainfall = reading * kfactor + offset

  if (rainfall > 0.0) {
    return rainfall
  }

  return 0
}
